<style lang="scss" scoped>
h1 {
  color: rgb(24, 174, 194);
  margin: 15px 0;
}
h3 {
  font-size: 20px;
}
p {
  font-weight: bold;
  font-size: 19px;
}
.info {
  font-size: 23px;
  font-weight: lighter;
  color: #fff;
  padding: 8px 10px;
  text-indent: 30px;
}
.info-col {
  background-color: rgb(24, 174, 194);
}
.col-12 {
  padding-left: 0;
}
//Адаптив
@media (min-width: 576px) and (max-width: 767.98px) {
  .info {
    text-align: justify;
    padding: 15px 5px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .info {
    padding: 15px 10px;
    font-size: 17px;
  }
}
@media (max-width: 370px) {
  h1 {
    font-size: 20px;
  }
}
</style>
<template>
  <div class="Prepodavaniye">
    <b-container>
      <b-row>
        <b-col cols="12">
          <b-breadcrumb :items="items"></b-breadcrumb>
        </b-col>
        <b-col cols="12">
          <h1>
            Преподавание в начальных классах
          </h1>
        </b-col>
        <b-col cols="12">
          <h3>
            Квалификация: <em>учитель начальных классов</em>
          </h3>
        </b-col>
        <b-col class="mb-3 info-col" cols="12" lg="6" xl="7">
          <p class="info">
            <em>
              Уникальность профессии учителя начальных классов заключается в совмещении сразу нескольких социальных статусов. Он и учитель, и воспитатель, наставник и помощник, защитник и вдохновитель, который призван помочь ребёнку приобрести не только знания об окружающем мире, овладеть умениями и навыками, но помочь адаптироваться в этом мире, раскрыть и проявить свои способности, почувствовать себя самостоятельной творческой личностью.
            </em>
          </p>
        </b-col>
        <b-col class="mb-3 d-none d-lg-block" cols="6" xl="5">
          <img class="img-fluid" src="../assets/img/others/prepodavaniye.jpg" alt="Преподавание в начальных классах">
        </b-col>
        <b-col cols="12">
          <p>
            Срок обучения 3 года 10 месяцев на базе 9 классов. Форма обучения очная.
          </p>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col cols="12">
          <b-tabs justified>
            <b-tab title="Необходимые навыки и знания для обучения на программе" active>
              <b-container>
                <b-row class="mt-3 mb-3">
                  <b-col class="d-none d-md-block" cols="3" offset="1">
                    <img class="img-fluid" src="../assets/img/others/book.png" alt="apple">
                  </b-col>
                  <b-col cols="12" md="7" offset-md="1">
                    <p>
                    Порядочность; <br>
                    Доброжелательность; <br>
                    Высокая ответственность; <br>
                    Организованность; <br>
                    Владение современными методиками и технологиями; <br>
                    Широкая эрудиция; <br>
                    Педагогическая интуиция; <br>
                    Дисциплинированность; <br>
                    Ответственность; <br>
                    Умение работать в команде; <br>
                    Грамотность речи; <br>
                    Компьютерная грамотность.
                    </p>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
            <b-tab title="Что предстоит изучить">
              <b-container>
                <b-row class="mt-3 mb-3">
                  <b-col class="d-none d-md-block" cols="3" offset="1">
                    <img class="img-fluid" src="../assets/img/others/teatcher.png" alt="">
                  </b-col>
                  <b-col cols="12" md="7" offset-md="1">
                    <p>
                      Педагогика и психология. Возрастная анатомия. Теоретические основы преподавания по программам начального общего образования. 
                      Основы организации внеурочной работы в области научно-познавательной деятельности. Основы деятельности классного руководителя.
                      Теоретические и прикладные аспекты методической работы.
                    </p>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
            <b-tab title="Профессиональная деятельность">
              <b-container>
                <b-row class="mt-3 mb-3">
                  <b-col class="d-none d-md-block" cols="2" offset="1">
                    <img class="img-fluid" src="../assets/img/others/specialist.png" alt="athom">
                  </b-col>
                  <b-col cols="12" md="8" offset-md="1">
                    <p>
                      Осуществляет учебный и воспитательный процесс. Обеспечивает досуг детей, их отдых и творческое развитие.
                    </p>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
            <b-tab title="Профессиональные и личные качества">
              <b-container>
                <b-row class="mt-3 mb-3">
                  <b-col class="d-none d-md-block" cols="3" offset="1">
                    <img class="img-fluid" src="../assets/img/others/partner.png" alt="man">
                  </b-col>
                  <b-col cols="12" md="7" offset-md="1">
                    <p>
                      Профессиональные качества: эмоциональная уравновешенность, развитые коммуникативные способности и эрудиция, высокая самоорганизация, непрерывное самосовершенствование и самообразование. <br>
                      Личные качества: наблюдательность, отзывчивость, внимательность, терпеливость, толерантность, трудолюбие, ответственность, дисциплинированность.
                    </p>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
            <b-tab title="Область применения полученных знаний">
              <b-container>
                <b-row class="mt-3 mb-3">
                  <b-col class="d-none d-md-block" cols="3" offset="1">
                    <img class="img-fluid" src="../assets/img/others/home.png" alt="">
                  </b-col>
                  <b-col cols="12" md="7" offset-md="1">
                    <p>
                      Учитель начальных классов – это специалист, который разбирается в азах каждого школьного предмета. Он знает, как привлечь внимание детей, как преподнести тему, как увлечь обучением. Учитель младших классов сочетает в себе функции преподавателя, воспитателя и психолога.<br>
                      Учителя начальных классов работают в общеобразовательных и частных школах, специализированных учебных заведениях и детских садах, учреждениях культуры и дополнительного образования, загородных лагерях и в детских досуговых центрах. Также, можно работать частным репетитором, квалифицированной гувернанткой, заниматься обучением и воспитанием детей на дому.
                    </p>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
      <!-- <SliderStudents /> -->
    </b-container>
  </div>
</template>

<script>
import SliderStudents from "../../src/components/SliderStudents";

export default {
  name: "Electric",
  components: {
    SliderStudents
  },
  data() {
      return {
        items: [
          {
            text: 'Специальности',
            href: '/Specialties'
          },
          {
            text: 'Преподавание в начальных классах',
            active: true
          }
        ]
      }
    }
};
</script>